export const ANALYTICS_TRACKING_STATUS = {
  noDecision: 'NO_DECISION',
  optedIn: 'OPTED_IN',
  optedOut: 'OPTED_OUT',
}
